import './CompareWorkshops.css';
import CompareWorkshopsRowImage from './CompareWorkshopsRowImage';

const CompareWorkshopsGeneral = ({ comparedWorkshops, comparedWorkshopDetails }) => {
    
    return (
        <div className='mb-6'>            
            <CompareWorkshopsRowImage
                title="Stakeholder distribution"
                imgPath="/demographics/stakeholder_distribution.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRowImage
                title="Gender distribution"
                imgPath="/demographics/gender_distribution.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRowImage
                title="Age distribution"
                imgPath="/demographics/age_distribution.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
        </div>
    );
};

export default CompareWorkshopsGeneral;
